if (!customElements.get("custom-show-more-button")) {
  class CustomShowMoreButton extends HTMLElement {
    constructor() {
      super();
      this.isShow = false;
      this.showButton = this.querySelector('.learn-more-button__show');
      this.hideButton = this.querySelector('.learn-more-button__hide');
      this.target = this.previousElementSibling.hasAttribute('data-show-content')
        ? this.previousElementSibling
        : null;

      this.showContent = this.showContent.bind(this);
      this.hideContent = this.hideContent.bind(this);
      this.toggleContent = this.toggleContent.bind(this);

    }

    connectedCallback() {
      if (this.target) {
        this.showButton.addEventListener('click', this.toggleContent);
        this.hideButton.addEventListener('click', this.toggleContent);
        if (this.target.getBoundingClientRect().height < 200) {
          this.style.display = 'none';
          this.target.classList.add('active');
        }
        // console.log('显示更多按钮已连接。');
      } else {
        // console.warn('找不到目标元素。');
      }
    }

    disconnectedCallback() {
      if (this.target) {
        this.showButton.removeEventListener('click', this.toggleContent);
        this.hideButton.removeEventListener('click', this.toggleContent);
        // console.log('显示更多按钮已断开连接。');
      }
    }

    toggleContent() {
      // console.log('切换内容。当前状态：', this.isShow ? '显示' : '隐藏');
      if (this.isShow) {
        this.hideContent();
      } else {
        this.showContent();
      }
    }

    showContent() {
      // console.log('显示内容。');
      this.target.style.maxHeight = '100%';
      this.toggleClass(true);
      this.showButton.style.display = 'none';
      this.hideButton.style.display = 'flex';
      this.isShow = true;
    }

    hideContent() {
      // console.log('隐藏内容。');
      this.target.style.maxHeight = '';
      this.toggleClass(false);
      this.showButton.style.display = 'flex';
      this.hideButton.style.display = 'none';
      this.isShow = false;
    }

    toggleClass(isActive) {
      if (isActive) {
        // console.log('添加 active 类。');
        this.target.classList.add('active');
      } else {
        // console.log('移除 active 类。');
        this.target.classList.remove('active');
      }
    }
  }

  customElements.define('custom-show-more-button', CustomShowMoreButton);
}